/**
 * Insert count actions - record snippet insert (API + local state)
 *
 * When a user inserts a snippet, we call the block service to increment insertCount
 * and optimistically update the snippet's insertCount in the store. The API call is
 * fire-and-forget; we do not await it.
 */
import type { StoreActionApi } from 'react-sweet-state';

import * as BlockServiceClient from '../../services/blockServiceClient.ts';
import type { SnippetsState } from '../snippetsStore.types.ts';

export const insertCountActions = {
	/**
	 * Records that a snippet was inserted: increments insertCount in the store immediately
	 * and calls the block service in the background (fire-and-forget).
	 */
	recordSnippetInsert:
		(snippetId: string) =>
		({ setState, getState }: StoreActionApi<SnippetsState>): void => {
			const { snippets } = getState();
			const updatedSnippets = snippets.map((s) =>
				s.snippetId === snippetId ? { ...s, insertCount: (s.insertCount ?? 0) + 1 } : s,
			);
			setState({ snippets: updatedSnippets });
			void BlockServiceClient.incrementSnippetInsertCount(snippetId);
		},
};
